export const SAVE_IMAGE_DETAIL_TIME_DELAY = 2000;
export const UPLOADED_IMAGES_PATH = 'uploaded-images';
